const About = () => {
  return <></>;
};

export default About;
